import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { listReportMedicationPdc } from 'api/patient';

// ----------------------------------------------------------------------

const initialState = {
    patients: {
        error: null,
        loaded: false,
        data: []
    }
};

const slice = createSlice({
    name: 'reportMedicationPdc',
    initialState,
    reducers: {
        setReportMedicationError(state, action) {
            state.patients.error = action.payload;
            state.patients.loaded = true;
        },

        getPatientsSuccess(state, action) {
            state.patients.data = action.payload;
            state.patients.loaded = true;
        },

        resetState(state) {
            state.patients = initialState.patients;
            state.type = initialState.type;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function medicationReportEntriesResetState() {
    return dispatch(slice.actions.resetState());
}

export function getMedicationReportEntries(type) {
    return async () => {
        try {
            const response = await listReportMedicationPdc(type);
            dispatch(slice.actions.getPatientsSuccess(response.data.patients));
        } catch (error) {
            dispatch(slice.actions.setReportMedicationError(error));
        }
    };
}
